import { queryOptions, useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";

import type { QueryConfig } from "@/lib/react-query";
import type { User } from "@/types/user";

export const getProfile = async () => {
  return api.get("/users/me/") as Promise<User>;
};

export const getProfileQueryOptions = () => {
  return queryOptions({
    queryKey: ["profile"],
    queryFn: getProfile,
  });
};

type UseProfileOptions = {
  queryConfig?: QueryConfig<typeof getProfile>;
};

export const useProfile = ({ queryConfig }: UseProfileOptions = {}) => {
  return useQuery({
    enabled: hasAccessToken(),
    ...getProfileQueryOptions(),
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    ...queryConfig,
  });
};
